module.exports = __webpack_public_path__ + "static/media/Play.684d7a31.svg";